import defaultAttributes from '../defaultAttributes';

const SortAsc = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M11 5h4' }],
    ['path', { d: 'M11 9h7' }],
    ['path', { d: 'M11 13h10' }],
    ['path', { d: 'm3 17 3 3 3-3' }],
    ['path', { d: 'M6 18V4' }],
  ],
];

export default SortAsc;
